import createReactComponent from '../createReactComponent';
export default createReactComponent('signal', 'Signal', [["path",{"d":"M20.5 10v4m-4-8v12M12 3v18M7.5 6v12m-4-8v4","key":"svg-0"}]]);